import Store from "../store";
const MarketFeatures = (() => {
  return {
    isEnabled: function(feature) {
      let currentLocale = Store.getState().locale;
      let featuresFlags = currentLocale.featureFlags;
      if (featuresFlags && featuresFlags[feature] !== undefined && featuresFlags[feature].value !== undefined) {
        return (
          featuresFlags[feature]["type"] === "market" &&
          featuresFlags[feature].value.find(
            m => m === currentLocale.country
          ) !== undefined
        );
      } else {
        return false;
      }
    },
    config: function() {
      let currentLocale = Store.getState().locale;
      if (
        currentLocale.featureFlags[currentLocale.country] !== undefined &&
        currentLocale.featureFlags[currentLocale.country]["type"] === "config"
      ) {
        return currentLocale.featureFlags[currentLocale.country]["value"];
      } else {
        return;
      }
    },

  };
})();
export default MarketFeatures;



// WEBPACK FOOTER //
// ./src/services/marketFeatures.js